import {Theme} from '@mui/material/styles';

import withStyles from '@mui/styles/withStyles';
import {orange} from '@mui/material/colors';
import Button from 'components/Button';

export const WarningButton = withStyles((theme: Theme) => ({
   root: {
      color: theme.palette.getContrastText(orange[800]),
      backgroundColor: orange[800],
      '&:hover': {
         backgroundColor: orange[700],
      },
   },
}))(Button);
